<template>
          <div class="cricle">{{ name | filterTwoName }}</div>
</template>

<script>
export default {
  name: 'AuthorPortrait',
  props: {
    creater: {
      type: String,
      default: ''
    }
  },
  computed: {
    name () {
      return this.creater
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
 .cricle {
      width: 40px;
      height: 40px;
      border-radius: 40px;
      background: #0054fb;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 13px;
    }
</style>
